import { Modal, Input, Checkbox } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { toggleDuplicateTaskModal } from '../../../../actions/modalAction';
import { duplicateTaskAction } from '../../../../redux/tasks/actions';
import { getTaskTmpProperties } from '../../../../redux/general/selectors';

const MODAL_STYLES = {
    body: {
        backgroundColor: '#FFFFFF',
        borderTop: '1px solid #ccc',
        borderBottomLeftRadius: '10px',
        borderBottomRightRadius: '10px',
    },
    header: {
        padding: '10px 15px',
    },
    title: {
        fontSize: '16px',
    },
};

const initialData = {
  taskTitle: '',
  taskDescription: true,
  parentTaskId: true,
  projects: true,
  files: true,
  assignee: false,
  tags: true,
  dueDate: false,
  subtasks: true,
  collaborators: false,
};

const DuplicateTaskModal = ({ task, isModalOpen, taskTmpProperties }) => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const sourceTask = task?._id ? task : taskTmpProperties;

    const [data, setData] = useState(initialData);

    useEffect(() => {
        if (isModalOpen) {
            const defaultTitle = `Duplicate of ${sourceTask?.taskTitle || 'Task'}`;
            setData((prev) => ({ ...prev, taskTitle: defaultTitle }));
        }
    }, [sourceTask, isModalOpen]);

    const closeModal = () => {
        dispatch(toggleDuplicateTaskModal(false));
        setData(initialData);
    };

    const handleCheckboxChange = (key) => {
        setData((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleTitleChange = (e) => {
        const value = e.target.value;
        setData((prev) => ({ ...prev, taskTitle: value }));
    };

    const handleCreateTask = () => {
        if (!data.taskTitle) return;
        dispatch(duplicateTaskAction(sourceTask?._id, data));
        closeModal();
    };

    return (
        <Modal
            title={intl.formatMessage({
                id: 'DUPLICATE_TASK',
                defaultMessage: 'Duplicate Task',
            })}
            open={isModalOpen}
            onCancel={closeModal}
            footer={null}
            styles={MODAL_STYLES}
            className="custom-modal"
        >
            <div className="px-4 mb-2">
                <p className="text-gray-700 mb-2 mt-3 text-xs">
                    <FormattedMessage id="TASK_NAME" defaultMessage="Task Name" />
                </p>
                <Input
                    value={data.taskTitle}
                    onChange={handleTitleChange}
                />
            </div>
            <p className="text-gray-700 my-3 px-4 text-xs">
                <FormattedMessage id="INCLUDE_TASK" defaultMessage="Include" />
            </p>
            <div className="space-y-2 flex flex-col px-4 mb-4">
                <Checkbox
                    checked={data.taskDescription}
                    onChange={() => handleCheckboxChange('taskDescription')}
                >
                    <FormattedMessage id="TASK_DESCRIPTION" defaultMessage="Task description" />
                </Checkbox>
                <Checkbox
                    checked={data.assignee}
                    onChange={() => handleCheckboxChange('assignee')}
                >
                    <FormattedMessage id="ASSIGNEE" defaultMessage="Assignee" />
                </Checkbox>
                {sourceTask?.subtasks?.length > 0 && (
                    <Checkbox
                        checked={data.subtasks}
                        onChange={() => handleCheckboxChange('subtasks')}
                    >
                        <FormattedMessage id="SUBTASKS" defaultMessage="Subtasks" />
                    </Checkbox>
                )}
                <Checkbox
                    checked={data.files}
                    onChange={() => handleCheckboxChange('files')}
                >
                    <FormattedMessage id="ATTACHMENTS" defaultMessage="Attachments" />
                </Checkbox>
                <Checkbox
                    checked={data.tags}
                    onChange={() => handleCheckboxChange('tags')}
                >
                    <FormattedMessage id="TAGS" defaultMessage="Tags" />
                </Checkbox>
                <Checkbox
                    checked={data.collaborators}
                    onChange={() => handleCheckboxChange('collaborators')}
                >
                    <FormattedMessage id="COLLABORATORS" defaultMessage="Collaborators" />
                </Checkbox>
                <Checkbox
                    checked={data.projects}
                    onChange={() => handleCheckboxChange('projects')}
                >
                    <FormattedMessage id="PROJECTS" defaultMessage="Projects" />
                </Checkbox>
                <Checkbox
                    checked={data.dueDate}
                    onChange={() => handleCheckboxChange('dueDate')}
                >
                    <FormattedMessage id="DUE_DATE" defaultMessage="Due date" />
                </Checkbox>
                {sourceTask?.parentTaskId && (
                    <Checkbox
                        checked={data.parentTaskId}
                        onChange={() => handleCheckboxChange('parentTaskId')}
                    >
                        <FormattedMessage id="PARENT_TASK" defaultMessage="Parent task" />
                    </Checkbox>
                )}
            </div>
            <div className="flex pb-4 pr-4 justify-end">
                <button
                    onClick={handleCreateTask}
                    className={`${!data.taskTitle
                            ? 'bg-blue-400 cursor-not-allowed'
                            : 'bg-blue-500 hover:bg-blue-400 cursor-pointer'
                        } h-9 rounded-md px-3 text-white border-none`}
                >
                    <FormattedMessage id="CREATE_NEW_TASK" defaultMessage="Create new task" />
                </button>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    taskTmpProperties: getTaskTmpProperties(state),
});

export default connect(mapStateToProps)(DuplicateTaskModal);
